import { useSearchParams } from "@remix-run/react";
import { PaginationInfo } from "../types";

type PaginationHook = {
  paginationInfo: PaginationInfo;
  onPageChange?: (page: number) => void;
  pushToHistory?: boolean;
  preventScrollReset?: boolean;
};

export function usePagination({
  paginationInfo,
  onPageChange,
  pushToHistory = true,
}: PaginationHook) {
  const [searchParams, setSearchParams] = useSearchParams();

  const { page, pages } = paginationInfo;

  const pageNumbers: number[] = [];
  if (pages > 3) {
    if (page <= 2) {
      pageNumbers.push(1, 2, 3);
      if (pages > 4) {
        pageNumbers.push(-1, pages);
      }
    } else if (page >= pages - 2) {
      pageNumbers.push(1, -1);
      pageNumbers.push(pages - 3, pages - 2, pages - 1, pages);
    } else {
      pageNumbers.push(1, -1);
      pageNumbers.push(page - 1, page, page + 1);
      pageNumbers.push(-1, pages);
    }
  } else {
    for (let i = 1; i <= pages; i++) {
      pageNumbers.push(i);
    }
  }
  const handlePageChange = (newPage: number) => {
    if (newPage > 0 && newPage <= pages) {
      if (pushToHistory) {
        searchParams.set("page", newPage.toString());
        setSearchParams(searchParams, {
          preventScrollReset: false,
        });
      }
      onPageChange?.(newPage);
    }
  };

  const handlePrevPage = () => handlePageChange(page - 1);

  const handleNextPage = () => handlePageChange(page + 1);

  const handlePageClick = (newPage: number) => handlePageChange(newPage);

  return {
    pageNumbers,
    handleNextPage,
    handlePageClick,
    handlePrevPage,
  };
}
